import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import Typography from "ds/components/Typography";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerFooter from "ds/components/Drawer/Footer";
import DocumentationButton from "components/DocumentationButton";
import { getDocsUrl } from "utils/getDocsUrl";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import styles from "./styles.module.css";

const RolesInfoDrawerContent = () => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Roles" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <Typography tag="h3" variant="p-t6">
          System roles
        </Typography>
        <Typography tag="p" variant="p-body2" className={styles.description}>
          Spacelift provides three system roles that can not be modified:
          <br />
          <br />
          <Typography tag="span" variant="p-t6">
            Read{" "}
          </Typography>
          - Grants full read access to all entities within the assigned space, with the ability to
          comment on runs.
          <br />
          <Typography tag="span" variant="p-t6">
            Write{" "}
          </Typography>
          - Extended read access with the ability to trigger runs and manage stack environment
          variables within the assigned space.
          <br />
          <Typography tag="span" variant="p-t6">
            Admin{" "}
          </Typography>
          - Grants full access to all entities within the assigned space, including attachments.
          When assigned to the root space, the role extends to managing organization-wide settings
          and spaces.
          <br />
          <br />
          <Typography tag="h3" variant="p-t6">
            Custom roles
          </Typography>
          To create a custom role, click the ‘Create role’ button. A custom role is a reusable set
          of permissions that can be assigned to users.
          <br />
          <br />
          <Typography tag="h3" variant="p-t6">
            Role assignment
          </Typography>
          You can assign multiple roles to a single entity within the same space. To enable any
          role, the user must first be granted the Read system role as a minimum permission
          baseline.
        </Typography>
        <DrawerFooter>
          <DocumentationButton
            to={getDocsUrl("/concepts/authorization/rbac-system#roles")}
            analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
          />
        </DrawerFooter>
      </DrawerBody>
    </>
  );
};

export default RolesInfoDrawerContent;
